import React, {
  useState,
  useEffect,
  useImperativeHandle,
  forwardRef,
  useRef,
} from "react";
import { checkBlackIcon } from "../../assets/icons";
import { EMPTY_STRING } from "../../constants";

const TextEditor = forwardRef(function TextEditor(props, ref) {
  const [value, setValue] = useState(props.value || EMPTY_STRING);
  const refInput = useRef();

  useEffect(() => {
    refInput.current.focus();
  }, []);

  useImperativeHandle(ref, () => ({
    getValue: () => value.trim(),
  }));

  return (
    <div className="flex items-center w-full h-full bg-white p-2 pl-4 gap-2">
      <input
        ref={refInput}
        className="w-full h-full outline-none border-none text-black text-sm"
        value={value}
        onChange={(event) => setValue(event.target.value)}
      />
      <img
        src={checkBlackIcon}
        alt="check-icon"
        className="w-4 h-4 cursor-pointer"
        onClick={() => props.api.stopEditing()}
      />
    </div>
  );
});

export default TextEditor;
